import React, { useEffect, useState } from "react";
import ProductCard from "../Card/ProductCard";
import { useDispatch, useSelector } from "react-redux";
import { getFilterProducts, getRecommendedProducts } from "../../appState/slices/product/productSlice";

const YouMayAlsoLike = ({ productId, categoryid, gender }) => {
    const products = useSelector(state => state.product.recommendedprods);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getRecommendedProducts(
            // gender: gender,
           productId
        ));
    }, [])

    return (
        <React.Fragment>
            <div className="row">
                {products.map((product, index) => {
                    return (
                        <div className="col-lg-6 col-md-6 col-sm-6 ps-1 pe-1 pb-2">
                            <ProductCard product={product} />
                        </div>
                    );

                })}
            </div>
        </React.Fragment>

    );
}

export default YouMayAlsoLike;